import { defineStore } from 'pinia';
import sfxLib from '@/sfx.js';

var defaultOptions = {
    diff: 2,
    ppr: 3,
    timer: 0,
    source: 'quotes',
};

var globalOptions = {
    sources: {
        'full': 'All The Puzzles',
    },
    ppr: {
        1: {
            color: '#00cccb',
        },
        3: {
            color: '#afcccb',
        },
        5: {
            color: '#c0a49d',
        },
        10: {
            color: '#7c73e6',
        },
        15: {
            color: '#fdb44b',
        }
    },
    puzzleValue: {
        length: 10,
        stopWord: 2,
        guessWord: 15,
        diffHi: 1.25,
        diffLo: 0.75,
    }
}

var defaultUser = {
    id: 1,
    avatar: 10,
    avatarLevel: 0,
    bust: 0,
    globalVolumeShow: 0,
    name: 'Guest Player',
    options: JSON.parse(JSON.stringify(defaultOptions)),
    puzzleHistory: [],
    tools: {
        coin: {
            id: 'coin',
            name: 'Coin',
            description: 'Shop',
            icon: require('@/assets/gfx/coin.png'),
            total: 0,
            active: 0,
            price: 0,
            sound: {},
        },
        avatar: {
            id: 'avatar',
            name: 'Avatar Alive',
            description: 'Bring your avatar to life',
            total: 0,
            active: 0,
            price: 1000,
            sound: {
                on: sfxLib.sfxLib.shieldUp,
                off: sfxLib.sfxLib.toolOff,
                hit: sfxLib.sfxLib.shieldBlock,
            }
        },
        shield: {
            id: 'shield',
            name: 'Shield',
            description: 'Blocks penalty for a wrong solution',
            icon: require('@/assets/gfx/shield.png'),
            total: 0,
            active: 0,
            price: 200,
            score: 5,
            sound: {
                on: sfxLib.sfxLib.shieldUp,
                off: sfxLib.sfxLib.toolOff,
                hit: sfxLib.sfxLib.shieldBlock,
            }
        },
        wand: {
            id: 'wand',
            name: 'Wand',
            description: 'Solves one unused clue',
            icon: require('@/assets/gfx/wand.png'),
            total: 0,
            price: 600,
            active: 0,
            sound: {
                on: sfxLib.sfxLib.wandOn,
                hit: sfxLib.sfxLib.wandActivate,
            }
        },
        unmask: {
            id: 'unmask',
            name: 'Unmask',
            description: 'Reveal the movie title',
            icon: require('@/assets/gfx/binocular.png'),
            total: 0,
            price: 100,
            active: 0,
            sound: {
                on: sfxLib.sfxLib.wandOn,
                hit: sfxLib.sfxLib.wandActivate,
            }
        },
        spotlight: {
            id: 'spotlight',
            name: 'Spotlight',
            description: 'Show which clues are right and wrong',
            icon: require('@/assets/gfx/magnifyglass.png'),
            total: 0,
            price: 400,
            active: 0,
            sound: {
                on: sfxLib.sfxLib.wandOn,
                hit: sfxLib.sfxLib.wandActivate,
            }
        },
    },
    totals: {
        score: 0,
        rounds: 0,
        puzzles: 0,
        guessRight: 0,
        guessWrong: 0,
        guessTotal: 0,
        successRate: 0,
        perfectGames: [],
    }
};

var allUsers = {
    appMode: '',
    paidMode: 'free',
    active: 1,
    welcome: 1,
    maxUsers: {
        free: 20,
        paid: 20,
    },
    globalVolume: 100,
    users: {
        1 : JSON.parse(JSON.stringify(defaultUser)),
    },
};

var defaultBonus = {
    diff: {
        1: {
            min: 50,
            factor: 1,
            award: {
                icon: 'game-icon game-icon-allied-star',
                wins: 2,
            }
        },
        2: {
             min: 75,
             factor: 3,
             award: {
                icon: 'game-icon game-icon-sunrise',
                wins: 3,
            }
        },
        3: {
            min: 90,
            factor: 5,
            award: {
                icon: 'game-icon game-icon-trophy',
                wins: 5,
            }
       },
    },
    userStyle: 25,
    perfectSolve: 5,
    perfectGame: 3,
};

var defaultPenalty = {
    diff: {
        1: {
            successRate: 20,
            tax: 10,
            pass: 20,
        },
        2: {
            successRate: 40,
            tax: 15,
            pass: 30,
        },
        3: {
            successRate: 60,
            tax: 25,
            pass: 50,
        },
    },
}

var defaultGame = {
    inProgress: 0,
    isPaused: 0,
    totalScore: 0,
    totalScoreMax: 0,
    totalScoreProgress: 0,
    bonusHistory: {},
    penaltyHistory: [],
    puzzleIdx: 0,
    puzzle: {},
    roundComplete: 0,
    decoys: {
        1: .10,
        2: .30,
        3: .50,
    },
    gameboard: {
        isStart: 0,
        isWin: 0,
        isReady: 0,
        token: 1,
        guessRight: 0,
        guessWrong: 0,
        guessTotal: 0,
        answer: -1,
        cluelength: 0,
        guessCount: 0,
        clueTimer: {
            started: 0,
            time: 0,
            handle: 0,
            init: {
                diff: {
                    1: 30,
                    2: 20,
                    3: 10,
                }
            }
        },
    }
}

export const useUserStore = defineStore('userStore',{
    state: () => ({
      users: JSON.parse(JSON.stringify(allUsers)),
    }),
    persist: {
        enabled: true,
    },
    getters: {
      user: function() {
          return this.users ? this.users.users[this.users.active] : {};
      },
      otherUsers: function() {
          var usersOther = JSON.parse(JSON.stringify(this.users.users));
          //delete usersOther[1];
          delete usersOther[this.users.active];
          return usersOther;
      },
    }, 
    actions: {
      genID: function() {
          return Date.now().toString(36) + Math.random().toString(36).substring(2);
      },
      newUser: function(options) {
          var userNew = JSON.parse(JSON.stringify(defaultUser));
          userNew.id = this.genID();
  
          if ( options.name ) {
              userNew.name = options.name;
          }
  
          if ( options.hasOwnProperty('avatar') ) {
              userNew.avatar = options.avatar;
          }
  
          this.users.users[userNew.id] = userNew;
          this.users.active = userNew.id;

          return userNew.id;
      },
      deleteUser: function(id) {
          delete this.users.users[id];
      },
      resetUsers: function(mode) {
        console.log('reset',mode);
        var u = JSON.parse(JSON.stringify(allUsers));
        if ( mode == 'debug' ) {
            u.users['1'].tools.shield.total = 500;
            u.users['1'].tools.wand.total = 500;
            u.users['1'].tools.unmask.total = 500;
            u.users['1'].tools.spotlight.total = 500;
            u.users['1'].totals.score = 1000;
            u.users['1'].totals.perfectGames = [];
            for (let x = 0; x < 10; x++) {
                u.users['1'].totals.perfectGames.push({ diff: 3, ppr: 10 });
                u.users['1'].totals.perfectGames.push({ diff: 1, ppr: 5 });
            };
        }
        this.users = u;
        location = "/";
      },
      chargeUser: function(amt) {
        this.user.totals.score = Number(this.user.totals.score) - Number(amt);
      },
    }
  });

export const useGameStore = defineStore('gameStore',{
  state: () => ({
    options: JSON.parse(JSON.stringify(globalOptions)),
    bonus: JSON.parse(JSON.stringify(defaultBonus)),
    penalty: JSON.parse(JSON.stringify(defaultPenalty)),
    currentGame: JSON.parse(JSON.stringify(defaultGame)),
    currentPuzzles: [],
  }),
  persist: false,
  getters: {

  }, 
  actions: {
    resetGame: function(data) {
        var defaults = JSON.parse(JSON.stringify(defaultGame));
        Object.assign(defaults, data);

        this.currentGame = defaults;
        this.currentPuzzles = [];
    },
  }
});
